
import {  TextField } from "@mui/material";
import { ChangeEventHandler } from "react";
import { debounce } from "lodash";

export const DebounceTextField = (props: any) => {
  const{value, id, name, label, hasError, helperText, onTextFieldChange} = props;
    
  const onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
      onTextFieldChange(e);
    };
  
    const debouncedOnChange = debounce(onChange, 500);
  
    return <TextField 
      id={id}
      name={name}
      label={label}
      className="w-full"
      defaultValue={value}
      value={value}
      onChange={(e)=>{
        onTextFieldChange(e);
        debouncedOnChange(e);
      }}
      error={hasError}
      helperText={helperText}
    />;
  };
  
